// This cache lives only in the current JavaScript page. It never writes to
// browser storage, and a different sign-in immediately replaces its owner.
let activeToken = null;
let cachedDraft = null;

const usableToken = (token) => typeof token === "string" && token.trim() !== "";
const clone = (value) => JSON.parse(JSON.stringify(value));

// Only mounting/reading a session may change the active account. An old
// asynchronous request must not reclaim this cache by writing its old token.
export const readForecastDraft = (token) => {
  const nextToken = usableToken(token) ? token : null;
  if (nextToken !== activeToken) {
    activeToken = nextToken;
    cachedDraft = null;
  }
  if (!activeToken || !cachedDraft) return null;
  return clone(cachedDraft);
};

export const writeForecastDraft = (token, draft) => {
  if (!usableToken(token) || token !== activeToken) return;
  const edits = Object.fromEntries(Object.entries(draft?.edits || {}).filter(([, entry]) =>
    entry && typeof entry === "object" &&
    String(entry.value) !== String(entry.originalValue)));
  if (Object.keys(edits).length === 0) {
    cachedDraft = null;
    return;
  }
  cachedDraft = clone({ month: draft.month, edits, retryKey: draft.retryKey || null });
};

export const clearForecastDraft = (token) => {
  if (usableToken(token) && token === activeToken) cachedDraft = null;
};
